import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { connect } from 'react-redux'
import { analytics } from 'services/Analytics'
import { withLocalization } from 'hocs/localization'
import { onCancelSubscription } from 'redux-app/actionCreators/subscription'
import { closeModal } from 'redux-app/modules/modals'
import { getModalDataByName } from 'redux-app/selectors/modals'
import ConfirmCancelSubscriptionModal from './ConfirmCancelSubscriptionModal'
import {getCancellationReasonList} from 'api/client/actions/subscriptions'
import { reduxForm } from 'redux-form'
import { createSelector } from "reselect"
import { CONFIRM_CANCEL_SUBSCRIPTION_MODAL_NAME } from '../../contants'

export const getReasonOptions = createSelector(
  (state, props) => props.reasonsList,
  reasonsList => reasonsList.map(({ id, name }) => ({
    value: id,
    label: name,
  })), 
)

interface IProps {
  name: string
}

export default compose<any, IProps>(
  withLocalization('profile.manageAccount.confirmCancelSubscriptionModal'),
  withState('reasonsList', 'setReasonsList', []),
  connect(
    (state, props) => ({
      isWithFee: getModalDataByName(state, { name: CONFIRM_CANCEL_SUBSCRIPTION_MODAL_NAME }).hasCancellationFee,
      fee: getModalDataByName(state, { name: CONFIRM_CANCEL_SUBSCRIPTION_MODAL_NAME }).cancellationFee,
      reasonOptions: getReasonOptions(state, props)
    }),
    {
      getCancellationReasonList,
      closeModal,
      onCancelSubscription
    },
    ),
  reduxForm({
    form: 'cancelationForm',
    enableReinitialize: true,
  }),
  withState('isSubmitting', 'setSubmittingStatus', false),
  withState('otherSelected', 'setOtherSelected', false),
  withState('valid', 'setValid', false),
  lifecycle({
    componentDidMount () {
      const { getCancellationReasonList, setReasonsList } = this.props
      getCancellationReasonList()
        .then(({ value: { result } }) => {            
          setReasonsList(result)
        })
    },
  }),
  withHandlers({
    onClose: ({ closeModal, name }) => () => closeModal({ name }),
    onSubmit: ({ setSubmittingStatus, onCancelSubscription, closeModal, name, cancellationReasonDetails }) => formValues => {      
      setSubmittingStatus(true)
      return onCancelSubscription(formValues)
        .then(() => {
          setSubmittingStatus(false)
          closeModal({ name })
          analytics.cancelSubscription()
        })
        .catch(() => {
          setSubmittingStatus(false)
        })
    }
  }),
)(ConfirmCancelSubscriptionModal)
